export enum HttpStatusCodes {
  Success = 200,
  NoContent = 204,
  Unauthorized = 401,
  NotFound = 404,
  BadRequest = 400,
  Forbidden = 403,
}
